export const SHOW_SUPERBLOCKS_HEADER_PARAM = "showSuperblocksHeader";
export const SHOW_LOADING_STATE_PARAM = "showLoadingState";
